import { isNativeApp } from '@/lib/nativeApp';

// Native-only soft-keyboard lifecycle. The Keyboard plugin is configured with
// resize:'body' (capacitor.config.ts), which shrinks the WebView while the
// keyboard is up — but position:fixed bottom chrome (persona/admin bottom nav)
// stays pinned to the shrunken viewport's bottom edge, sitting directly above
// the keyboard and covering focused inputs on input-heavy screens (chat
// composer, signup, profile forms). While the keyboard is open we tag <body>
// with `keyboard-open`; CSS hides [data-keyboard-avoid] elements for the
// duration. No-op on web/PWA (browser keyboards use visual-viewport resizing
// and the bottom nav is not an overlap hazard there).

let initialized = false;

export async function initNativeKeyboard(): Promise<void> {
  if (!isNativeApp() || initialized) return;
  initialized = true;
  try {
    const { Keyboard } = await import('@capacitor/keyboard');
    await Keyboard.addListener('keyboardWillShow', () => {
      document.body.classList.add('keyboard-open');
    });
    await Keyboard.addListener('keyboardWillHide', () => {
      document.body.classList.remove('keyboard-open');
    });
  } catch (e) {
    // Plugin unavailable (old shell / web fallback) — inputs still work,
    // only the nav-hide nicety is lost.
    console.warn('Keyboard listeners unavailable:', e);
  }
}
